module.exports = __webpack_public_path__ + "static/media/playstore-5a.96e7564b.png";